import apiClient from '../utils/apiClient'
import { normalizeExposure } from './objectDistributionPolicy'

function target(value) {
	if (!value || !['PERSONAL', 'TEAM'].includes(value.kind) || !/^[1-9]\d{11}$/.test(String(value.reldoId || ''))) throw new TypeError('Invalid share target')
	const contacts = Array.isArray(value.publicContacts)
		? value.publicContacts.filter(contact => typeof contact?.type === 'string' && typeof contact?.value === 'string').map(contact => Object.freeze({ type: contact.type, value: contact.value }))
		: []
	const normalized = {
		kind: value.kind,
		reldoId: String(value.reldoId),
		name: typeof value.name === 'string' ? value.name : null,
		systemLabelKey: typeof value.systemLabelKey === 'string' ? value.systemLabelKey : null,
		logoObjectKey: typeof value.logoObjectKey === 'string' ? value.logoObjectKey : null,
		publicContacts: Object.freeze(contacts),
	}
	if (value.kind === 'PERSONAL') normalized.professional = Object.freeze({
		displayName: typeof value.professional?.displayName === 'string' ? value.professional.displayName : null,
		title: typeof value.professional?.title === 'string' ? value.professional.title : null,
		avatarObjectKey: typeof value.professional?.avatarObjectKey === 'string' ? value.professional.avatarObjectKey : null,
		contacts: Object.freeze(Array.isArray(value.professional?.contacts) ? value.professional.contacts.filter(contact => typeof contact?.type === 'string' && typeof contact?.value === 'string').map(contact => Object.freeze({ type: contact.type, value: contact.value })) : []),
	})
	return Object.freeze(normalized)
}

function distribution(value) {
	if (!value || !/^[1-9]\d*$/.test(String(value.objectId || '')) || !Array.isArray(value.shares)) throw new TypeError('Invalid object distribution')
	return Object.freeze({ objectId: String(value.objectId), exposure: normalizeExposure(value.exposure), shares: Object.freeze(value.shares.map(target)) })
}

export class ObjectDistributionApi {
	constructor(http = apiClient) { this.http = http }
	async get(objectId) { return distribution((await this.http.get(`/api/objects/${objectId}/distribution`)).data) }
	async setExposure(objectId, exposure) {
		const response = (await this.http.put(`/api/objects/${objectId}/exposure`, { exposure: normalizeExposure(exposure) })).data
		return Object.freeze({ objectId: String(response.id), exposure: normalizeExposure(response.exposure) })
	}
	async replaceShares(objectId, shares) {
		const targetReldoIds = [...new Set(shares.map(item => target(item).reldoId))]
		return distribution((await this.http.put(`/api/objects/${objectId}/shares`, { targetReldoIds })).data)
	}
}

export default new ObjectDistributionApi()
